import './styles.css';

import useAuth from '../../../auth/useAuth';

import assignmentLogoReviewSessions from './images/assignment-logo-review-sessions.png';
import assignmentLogoClassification from './images/assignment-logo-classification.png';
import assignmentLogoBalancedEquation from './images/assignment-logo-balanced-equation.png';
import assignmentLogoNormalBalance from './images/assignment-logo-normal-balance.png';
import assignmentLogoThePrinciples from './images/assignment-logo-the-principles.png';

import { assignmentTypeMappings } from '../../../vars';
import AssignmentItem from './item';
import { Link } from 'react-router-dom';

export default function AssignmentType({ 
  user,
  assignmentType,
  assignments,
  onTournamentDeletionConfirm,
  onGameDeletionConfirm,
  games,
  sessions,
  bestScores
}) {
  const { isInstructor } = useAuth();

  const assignmentTypeImages = {
    'Review Sessions': assignmentLogoReviewSessions,
    'Account Classification': assignmentLogoClassification,
    'Balanced Equation': assignmentLogoBalancedEquation,
    'Normal Balance': assignmentLogoNormalBalance,
    'The Principles': assignmentLogoThePrinciples,
  };

  const imageSrc = assignmentTypeImages[assignmentType];

  const gameTypeTitles = {
    'Account Classification': 'Classification',
    'Normal Balance': 'Normal Balance',
  };

  const assignmentTypeShortened = Object.entries(assignmentTypeMappings).find(([key]) => assignmentType?.includes(key))?.[1] || '';
  
  // Every intro route is nested under `level/:levelNumber/intro`, so the
  // Overview link needs `/level/1/intro` on every game type — not just
  // Balanced Equation. Without `/level/1` these links hit routes that
  // don't exist and 404. The prefix maps the shortened key to its route
  // segment (only Principles / Balanced Equation differ from their key).
  const gameTypeRoutePrefix = assignmentTypeShortened === 'equation'
    ? 'balanced-equation'
    : assignmentTypeShortened === 'principles'
      ? 'the-principles'
      : assignmentTypeShortened;
  const gameTypeUrl = `${gameTypeRoutePrefix}/level/1`;

  const handleAssignmentDeletionConfirm = (assignmentId, onSuccessDeleteCallback) => {
    if(assignmentTypeShortened === 'review-sessions') {
      onTournamentDeletionConfirm?.(assignmentId, onSuccessDeleteCallback);
    } else {
      onGameDeletionConfirm?.(assignmentId, onSuccessDeleteCallback);
    }
  }

  const relevantDeletionConfirm = assignmentTypeShortened === 'review-sessions'
    ? onTournamentDeletionConfirm
    : onGameDeletionConfirm;

  return (
    <div className={`assignment-type ${assignmentTypeShortened}`}>
      <div className="assignment-type-heading">
        {imageSrc && <img src={imageSrc} alt={assignmentType} className="game-logo" />}
        <h3>{gameTypeTitles[assignmentType] || assignmentType}</h3>

        {
          assignmentTypeShortened !== 'review-sessions' && 
            <Link to={`/${gameTypeUrl}/intro?overview`} className="assignment-overview-link">Overview</Link>
        }
        
      </div>
      {
        assignments.map((assignment, index) => {
          const currentGameSessions = sessions.filter(session => session.game === assignment.id && user?.id === session.user);

          const bestScore = bestScores?.[assignment.id];
          const currentGameScore = bestScore?.totalPoints || 0;
          const rank = bestScore?.rank || 'Noob';
            
          return(
            <AssignmentItem 
              key={index}
              user={user}
              assignment={assignment}
              assignmentType={assignmentTypeShortened}
              onTournamentDeletionConfirm={onTournamentDeletionConfirm}
              onAssignmentDeletionConfirm={(isInstructor() && relevantDeletionConfirm) ? handleAssignmentDeletionConfirm : null}
              sessions={sessions}
              games={games}
              currentGameSessions={currentGameSessions}
              currentGameScore={currentGameScore}
              rank={rank}
            />
          )
        })
      }
    </div>
  );
}
